// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-wrapper-table-time-cell .fi-wrapper-table-a-cell {
  color: var(--fi-color-light);
  transition: 0.2s;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-wrapper-table/cells/fi-wrapper-table-time-cell/fi-wrapper-table-time-cell.component.scss"],"names":[],"mappings":"AACI;EACI,4BAAA;EACA,gBAAA;AAAR","sourcesContent":[".fi-wrapper-table-time-cell {\r\n    .fi-wrapper-table-a-cell {\r\n        color: var(--fi-color-light);\r\n        transition: 0.2s;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
